import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { CapacityModel } from '@smarttask-common/src/lib/models/Resource/CapacityModel';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class CapacityHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.capacity_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.capacity_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.capacity_organization_update, (model: CapacityModel) => {
            this.broadcast(SharedEventNameEnum.capacity_organization_update, { capacity: model });
        });

        this.on(SharedEventNameEnum.capacity_job_role_update, (job_role_id: string, model: CapacityModel) => {
            this.broadcast(SharedEventNameEnum.capacity_job_role_update, { job_role_id, capacity: model });
        });

        // Note: pre-existing - broadcast under capacity_organization_update, not capacity_user_update.
        this.on(SharedEventNameEnum.capacity_user_update, (user_id: number, model: CapacityModel) => {
            this.broadcast(SharedEventNameEnum.capacity_organization_update, { user_id, capacity: model });
        });
    };
}
